import { useState, useEffect, useRef } from "react";
import { Modal, Button, Form, Row, Col, Card } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faX, faSearch, faCreditCard, faCheckCircle, faCircleInfo, faPrint, faArrowRight, faPercent,
  faSave, faDollarSign, faUpload, faImage, faTrashAlt, faMapMarkerAlt, faPlus, faMinus, 
  faTrash,
  faMapPin} from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
//import { NumericFormat } from "react-number-format";
import extorn from "../assets/img/remove.svg";
import "./componentsCss/PaymentModal.css";
import api from "../services/api.js";
import { useMemo } from "react";
import courtesy from "../assets/img/courtesy-selected.png";
import { PDFDocument } from "pdf-lib";
import FeeSelectorModal from "./TaxCard.js";
import { formatCurrency, formatDateDDMMYYYY, formatMoney } from "../utils/formats.js";
import Globals from "../Globals.js";
import parseMaskedMoney from '../utils/parseMaskedMoney.js';

const PaymentModal = ({
  schedule,
  patient,
  onClose,
  onSavePayment,
  onRefund,
}) => {
  /* ─────────── estados principais ─────────── */
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedProcedures, setSelectedProcedures] = useState([]);
  const [payments, setPayments] = useState([
    { method: "credit", amount: 0, tax: 0 },
  ]); // lista dinâmica de meios de pagamento
  const [paymentStep, setPaymentStep] = useState("select"); // select, confirm, success

  /* descontos / total personalizado */
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState(0);
  const [isEditingTotal, setIsEditingTotal] = useState(false);
  const [customTotal, setCustomTotal] = useState(0);
  //const [discountReason, setDiscountReason] = useState("");

  /* comprovante geral da transação */
  const [receiptFile, setReceiptFile] = useState(null);
  // comprovantes enviados
  const [receipts, setReceipts] = useState([]); // [{file, preview}]
  const [receiptPreview, setReceiptPreview] = useState(null);
  const fileInputRef = useRef(null);

  //console.log("schedule", schedule);
  //console.log("Patient", patient);

  /* extorno */
  const [refundProcedures, setRefundProcedures] = useState([]);

  const [showFeeSelector, setShowFeeSelector] = useState(false);
  const [currentIdx, setCurrentIdx] = useState(0);

  /* setores – caso queira reativar seleção por setor */
  const [sectors, setSectors] = useState([]);

  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [newAddress, setNewAddress] = useState({
    street: '',
    number: '',
    district: '',
    city: '',
    state: '',
    complement: '',
    zipcode: '',
    default: false
  });

  // 1. Garante que existe um array e achata tudo em uma lista única de items.
  const allItems = (schedule?.schedules ?? []).flatMap((s) => s.items ?? []);

  const unpaidProcedures = allItems.filter(
    (item) => item.agreement === null && !item.is_paid
  );

  const paidProcedures = allItems.filter(
    (item) => item.agreement === null && item.is_paid
  );

  console.log('procedimentos', allItems)
  console.log('nao pagos', unpaidProcedures)
  console.log('pagos', paidProcedures)

  useEffect(() => {
    console.log("Payments atualizados:", payments);
  }, [payments]);

  useEffect(() => {
    const uniqueSectors = [
      ...new Set(allItems.map((proc) => proc.setor_name || "Geral")),
    ];

    setSectors(uniqueSectors);
  }, [schedule]);

  useEffect(() => {
    console.log("schedule veio do pai:", schedule.schedules);
  }, [schedule]);

  /* debug consoles solicitados pelo usuário */
  // useEffect(() => {
  //   console.log("✅ pagos selecionados:", refundProcedures);
  //   console.log("❌ NÃO pagos selecionados:", selectedProcedures);
  // }, [refundProcedures, selectedProcedures]);

  useEffect(() => {
    setSelectedProcedures([]);
    setRefundProcedures([]);
    setPayments([{ method: "credit", amount: 0, tax: 0 }]);
  }, [schedule]);

  useEffect(() => {
    const getAddresses = async () => {
      if (paymentStep !== 'address') return;

      try {
        const response = await api.get(`api/search/address/customers/${patient.id}`);
        const addresses = response.data.data;
        setAddresses(addresses);

        const defaultAddress = addresses.find(addr => addr.default);
        if (defaultAddress) {
          setSelectedAddress(defaultAddress.id);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getAddresses();
  }, [paymentStep, patient.id]);

  // useEffect(() => {
  //   console.log("✅ pagos:", paidProcedures);
  //   console.log("❌ NÃO pagos:", unpaidProcedures);
  // }, [paidProcedures, unpaidProcedures]);

  //recibo
  // useEffect(() => {
  //   console.log("recibo:", receiptFile);
  //   console.log("Recibos: ", receipts);
  // }, [receiptFile, receipts]);

  const currentNetTotal = useMemo(() => {
    return payments.reduce((acc, payment) => {
      const valor = parseFloat(payment.amount) || 0;
      const taxa = parseFloat(payment.tax) || 0;

      const valorLiquido = valor + (valor * taxa) / 100;
      return acc + valorLiquido;
    }, 0);
  }, [payments]);

  const handleConfirmFee = ({ brand, installments, tax }) => {
    console.log("ConfirmFee:", { idx: currentIdx, brand, installments, tax });
    setPayments((old) =>
      old.map((p, i) =>
        i === currentIdx
          ? {
            ...p, // preserva method, amount, etc
            brand,
            installments,
            tax,
          }
          : p
      )
    );
    setShowFeeSelector(false);
  };

  const openSelector = (idx) => {
    setCurrentIdx(idx);
    setShowFeeSelector(true);
  };

  const buildFormData = async () => {
    // 1.1. Monte o objeto de dados (sem “receipts” no JSON)
    const payload = {
      scheduling_id: schedule.schedules[schedule.schedules.length - 1].id, //pega o ultimo
      clinic_id: schedule.schedules[schedule.schedules.length - 1].clinic_id,
      affiliate_company_id: schedule.schedules[schedule.schedules.length - 1].affiliate_company_id,
      patient: { id: patient.id, name: patient.name, cpf: patient.cpf },
      customer_saved_adresse_id: selectedAddress,
      subtotal,
      // força sempre vir com objeto, mesmo que seja tudo zero
      discount: {
        type: discountValue > 0 ? discountType : "percentage",
        value: discountValue > 0 ? discountValue : 0,
        amount: discountValue > 0 ? calculateDiscount() : 0,
      },
      total: totalAmount,
      payment_methods: payments.map((p) => ({
        method: p.method,
        amount: parseMaskedMoney(p.amount),
        tax: p.tax || 0,
        installments: p.installments || 1,
      })),
      procedures: selectedProcedures.map((p) => ({
        clinic_procedure_id: p.clinic_procedure_id,
        procedure_id: p.procedure_id,
        professional_id: p.professional_id,
        procedure_name: p.procedure_name,
        quantity: p.quantity,
        executing_company: p.executing_company,
        requesting_company: p.requesting_company,
        selling_price: p.selling_price,
        cost_price: p.cost_price,
      })),
    };

    // 1.2. Gere o PDF unificado
    const mergedBytes = await buildMergedReceipt(receipts);
    const blob = new Blob([mergedBytes], { type: "application/pdf" });
    const mergedFile = new File([blob], "comprovantes.pdf", {
      type: "application/pdf",
    });
    console.log("📄 mergedFile:", mergedFile);
    console.log("📂 blob:", blob);
    console.log("📦 receipts:", receipts);

    // 1.3. Monte o FormData
    const form = new FormData();
    form.append("merged_receipt", mergedFile);
    form.append("data", JSON.stringify(payload));

    console.log("formData Dentro da função de buildFormData", form);
    for (let pair of form.entries()) {
      console.log(`${pair[0]}:`, pair[1]);
    }

    return form;
  };

  //Juntar os comprovantes
  const buildMergedReceipt = async (receipts) => {
    const mergedPdf = await PDFDocument.create();

    for (const { file } of receipts) {
      const data = await file.arrayBuffer();

      if (file.type === "application/pdf") {
        // anexa cada página do PDF existente
        const donor = await PDFDocument.load(data);
        const pages = await mergedPdf.copyPages(donor, donor.getPageIndices());
        pages.forEach((p) => mergedPdf.addPage(p));
      } else {
        // transforma imagem em página A4 (ou ajusta ao tamanho original)
        const imgBytes = data;
        let img, dims;
        if (file.type === "image/png") img = await mergedPdf.embedPng(imgBytes);
        else img = await mergedPdf.embedJpg(imgBytes);

        dims = img.scale(1);
        const page = mergedPdf.addPage([dims.width, dims.height]);
        page.drawImage(img, {
          x: 0,
          y: 0,
          width: dims.width,
          height: dims.height,
        });
      }
    }

    // opcional: metadados
    mergedPdf.setTitle("Comprovantes de Pagamento");
    mergedPdf.setAuthor("Achemed");

    return await mergedPdf.save(); // Uint8Array
  };

  /* ─────────── helpers de forma de pagamento ─────────── */
  const hasCourtesy = payments.some((p) => p.method === "courtesy");
  const paidSoFar = payments.reduce((sum, p) => sum + parseMaskedMoney(p.amount), 0);

  const subtotal = selectedProcedures.reduce(
    (tot, proc) => tot + (Number(proc.selling_price) * (proc.quantity || 1)),
    0
  );

  const PAYMENT_OPTIONS = [
    { value: "credit", label: "Cartão de Crédito" },
    { value: "debit", label: "Cartão de Débito" },
    { value: "cash", label: "Dinheiro" },
    { value: "pix", label: "PIX" },
    { value: "courtesy", label: "Cortesia" },
  ];

  const handleQuantityChange = (e, procedureId, delta) => {
    console.log('clicou')
    e.stopPropagation(); // Impede que o clique no botão desmarque a linha

    setSelectedProcedures((prev) =>
      prev.map((p) => {
        if (p.procedure_id === procedureId) {
          const currentQtd = p.quantity || 1;
          const newQtd = Math.max(1, currentQtd + delta); // Mínimo de 1
          return { ...p, quantity: newQtd };
        }
        return p;
      })
    );
  };

  // const buildPayload = () => ({
  //   scheduling_id: schedule.schedules[0].id,
  //   clinic_id: schedule.schedules[0].clinic_id,
  //   affiliate_company_id: schedule.schedules[0].affiliate_company_id,

  //   patient: {
  //     id: patient.id,
  //     name: patient.name,
  //     cpf: patient.cpf,
  //   },
  //   subtotal,
  //   discount:
  //     discountValue > 0
  //       ? {
  //         type: discountType,
  //         value: discountValue,
  //         amount: calculateDiscount(),
  //       }
  //       : null,
  //   total: totalAmount,
  //   payment_methods: payments.map((p) => ({
  //     method: p.method,
  //     amount: p.amount,
  //     tax: p.tax || 0,
  //     installments: p.installments || 1,
  //   })),

  //   procedures: selectedProcedures.map((p) => ({
  //     clinic_procedure_id: p.clinic_procedure_id,
  //     procedure_id: p.procedure_id,
  //     professional_id: p.professional_id,
  //     procedure_name: p.procedure_name,
  //     quantity: p.quantity,
  //     executing_company: p.executing_company,
  //     requesting_company: p.requesting_company,
  //     selling_price: p.selling_price,
  //     cost_price: p.cost_price,
  //   })),
  //   // Envie os binários ou referências conforme seu backend exigir
  //   receipts: receipts.map(({ file }) => file.name),
  // });

  // verificação de pagamento
  const isMethodInUse = (method, currentIdx) =>
    payments.some((p, i) => i !== currentIdx && p.method === method);

  const handleMethodChange = (idx, method) => {
    // se já existir em outra posição, impede
    if (isMethodInUse(method, idx)) {
      Swal.fire({
        icon: "warning",
        title: "Método já utilizado",
        text: "Escolha outro meio de pagamento.",
      });
      return;
    }

    if (method === "courtesy") {
      // mantém regra exclusiva de cortesia
      setPayments([
        { method: "courtesy", amount: totalAmount, installments: 1 },
      ]);
    } else {
      // remove cortesia, se existir, e aplica mudança normal
      setPayments((prev) =>
        prev
          .filter((p) => p.method !== "courtesy")
          .map((p, i) => (i === idx ? { ...p, method, amount: 0, tax: 0 } : p))
      );
    }
  };

  // ──────────────────────────────────────────────────────────────────────────────

  // 🔄 2. Efeito para logar pagamentos no console
  // useEffect(() => {
  //   console.log("💰 Pagamentos salvos:", payments);
  // }, [payments]);

  const calculateDiscount = () => {
    if (discountType === "percentage") return (subtotal * discountValue) / 100;
    return discountValue;
  };

  const calculateTotal = () => {
    if (isEditingTotal && customTotal > 0) return customTotal;
    const discount = calculateDiscount();
    return Math.max(0, subtotal - discount);
  };

  const totalAmount = calculateTotal();
  const remaining = Math.max(0, totalAmount - paidSoFar);

  const updatePayment = (idx, key, value) =>
    setPayments((old) =>
      old.map((p, i) => (i === idx ? { ...p, [key]: value } : p))
    );

  const addPayment = () => {
    const usados = payments.map((p) => p.method);
    // ignora cortesia na busca
    const proximo = PAYMENT_OPTIONS.filter((o) => o.value !== "courtesy").find(
      (o) => !usados.includes(o.value)
    );

    if (!proximo) {
      Swal.fire({
        icon: "info",
        title: "Todos os métodos já foram usados",
      });
      return;
    }

    setPayments((old) => [
      ...old,
      { method: proximo.value, amount: 0, tax: 0 },
    ]);
  };

  const removePayment = (idx) =>
    setPayments((old) => old.filter((_, i) => i !== idx));

  /* ─────────── seleção / deselect itens ─────────── */
  const allSelected =
    unpaidProcedures.length > 0 &&
    unpaidProcedures.length === selectedProcedures.length;

  const handleSelectAll = () => {
    if (allSelected) setSelectedProcedures([]);
    else setSelectedProcedures([...unpaidProcedures]);
  };

  const handleSelectProcedure = (procedure) => {
    const isSelected = selectedProcedures.some(
      (p) => p.procedure_id === procedure.procedure_id
    );

    if (isSelected) {
      setSelectedProcedures((prev) =>
        prev.filter((p) => p.procedure_id !== procedure.procedure_id)
      );
    } else {
      // Garante quantity: 1 (ou o que vier do banco) ao selecionar
      setSelectedProcedures((prev) => [...prev, { ...procedure, quantity: procedure.quantity || 1 }]);
    }
  };

  const handleSelectRefund = (procedure) => {
    const isSelected = refundProcedures.some(
      (p) => p.clinic_procedure_id === procedure.clinic_procedure_id
    );

    if (isSelected) {
      setRefundProcedures((prev) =>
        prev.filter(
          (p) => p.clinic_procedure_id !== procedure.clinic_procedure_id
        )
      );
    } else {
      setRefundProcedures((prev) => [...prev, procedure]);
    }
  };

  /* ─────────── desconto / total custom ─────────── */
  const handleDiscountTypeChange = (type) => {
    setDiscountType(type);
    setDiscountValue(0);
    setIsEditingTotal(false);
    setCustomTotal(0);
  };

  const handleDiscountValueChange = (e) => {
    const value = Number.parseFloat(e.target.value) || 0;
    if (discountType === "percentage") setDiscountValue(Math.min(value, 100));
    else setDiscountValue(Math.min(value, subtotal));
    setIsEditingTotal(false);
    setCustomTotal(0);
  };

  const handleStartEditTotal = () => {
    setIsEditingTotal(true);
    setCustomTotal(totalAmount);
    setDiscountType("fixed");
    setDiscountValue(0);
  };

  const handleSaveCustomTotal = () => {
    if (customTotal >= 0) {
      const newDiscount = Math.max(0, subtotal - customTotal);
      setDiscountType("fixed");
      setDiscountValue(newDiscount);
      setIsEditingTotal(false);
    }
  };

  const handleCancelEditTotal = () => {
    setIsEditingTotal(false);
    setCustomTotal(0);
  };

  /* ─────────── comprovante upload ─────────── */
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setReceiptFile(file);
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = () => setReceiptPreview(reader.result);
      reader.readAsDataURL(file);
    } else setReceiptPreview(null);
  };
  const handleFilesChange = (e) => {
    const files = Array.from(e.target.files);

    const newReceipts = files.map((file) => ({
      file,
      preview: file.type.startsWith("image/")
        ? URL.createObjectURL(file)
        : null,
    }));

    setReceipts((prev) => [...prev, ...newReceipts]);
  };

  const removeReceipt = (idx) =>
    setReceipts((old) => old.filter((_, i) => i !== idx));

  const handleRemoveFile = () => {
    setReceiptFile(null);
    setReceiptPreview(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  /* ─────────── ações pagamento /  ─────────── */
  const handleAdvance = () => {
    if (selectedProcedures.length === 0) return;
    if (remaining > 0) {
      Swal.fire({
        icon: "warning",
        title: "Ainda faltam",
        text: `Ainda faltam ${formatMoney(remaining)} para fechar o total.`,
        confirmButtonText: "Voltar",
      }).then((result) => {
        if (!result.isConfirmed) onClose();
      });
      return;
    }
    setPaymentStep("address");
  };

  const handleAddressSelect = (addressId) => {
    setSelectedAddress(addressId);
  };

  const handleNewAddressSubmit = async () => {
    try {
      const response = await api.post('api/address/customers', {
        ...newAddress,
        customer_id: patient.id
      });

      const newAddr = response.data.data;
      setAddresses(prev => [...prev, newAddr]);

      if (newAddress.default) {
        setSelectedAddress(newAddr.id);
      }

      setShowAddressModal(false);
      setNewAddress({
        address: '',
        number: '',
        complement: '',
        neighborhood: '',
        zip_code: '',
        city: '',
        default: false
      });

      Swal.fire({
        icon: 'success',
        title: 'Endereço cadastrado com sucesso!',
        timer: 1500
      });
    } catch (error) {
      console.error(error);
      Swal.fire({
        icon: 'error',
        title: 'Erro ao cadastrar endereço',
        text: 'Tente novamente.'
      });
    }
  };

  const handleAdvanceFromAddress = () => {
    if (!selectedAddress) {
      Swal.fire({
        icon: 'warning',
        title: 'Selecione um endereço',
        text: 'Por favor, selecione um endereço para continuar.'
      });
      return;
    }
    setPaymentStep('confirm');
  };

  const handleConfirmPayment = async () => {
    try {
      const formData = await buildFormData(); // ✅ usa a função correta

      console.log("FormData:", formData.get("data"));
      console.log("Arquivo PDF:", formData.get("merged_receipt"));

      if (typeof onSavePayment === "function") {
        await onSavePayment(formData);
      }

      setPaymentStep("success");
    } catch (err) {
      console.error(err);
      Swal.fire({
        icon: "error",
        title: "Erro",
        text: "Falha ao enviar o PDF unificado.",
      });
    }
  };

  // const handlePrintReceipt = async () => {
  //   await api.post('api/cashiers/pos/budget', {
  //     clinic_procedure_id: selectedProcedures[0].clinic_procedure_id,
  //     shopper_id: 14 // FIXO ACHEMED
  //   })
  //     .then(response => {
  //       console.log(response.data);
  //       const pdfPath = Globals.BASE_URL + '/storage/' + response.data.path

  //       //does it work to open pdfPath to print?
  //       window.print()
  //     })
  // };
  const handlePrintReceipt = async (procedures) => {
    // Show loading SweetAlert
    Swal.fire({
      title: 'Gerando Recibo...',
      text: 'Aguarde ...',
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading()
      }
    })

    // console.log(procedures)
    // console.log(procedures.map(proc => proc.procedure_id));
    // console.log(procedures.map(proc => proc.scheduling_id));

    try {
      const response = await api.post('api/cashiers/pos/receipt', {
        clinic_procedure_id: procedures[procedures.length - 1].clinic_procedure_id,
        shopper_id: 14, // FIXO ACHEMED,
        procedures: procedures.map(proc => ({
          procedure_id: proc.procedure_id,
          scheduling_id: proc.scheduling_id
        }))
      })

      const pdfPath = Globals.BASE_URL + '/storage/' + response.data.path

      Swal.close();

      Swal.fire({
        icon: 'success',
        title: 'Recibo gerado com sucesso!',
        showConfirmButton: true,
        confirmButtonText: 'Abrir em uma nova guia',
        allowOutsideClick: false,
      })
        .then((result) => {
          if (result.isConfirmed) {
            window.open(pdfPath, '_blank');
            //onClose();
          }
        });

    } catch (error) {
      Swal.close()
      Swal.fire({
        icon: 'error',
        title: 'Erro!',
        text: 'Erro ao gerar recibo.',
        confirmButtonText: 'OK'
      })
      console.error(error)
    }
  }

  const handleConfirmRefund = () => {
    if (refundProcedures.length === 0) return;

    if (typeof onRefund === "function") {
      onRefund(refundProcedures);
    }

    console.log("Procedimentos a extornar:", refundProcedures);

    api
      .delete("/api/cashiers/refund-items", {
        data: {
          clinic_procedure_ids: refundProcedures.map(
            (p) => p.clinic_procedure_id
          ),
        },
      })
      .then(() => {
        console.log(
          "Extorno registrado com sucesso!",
          refundProcedures.map((p) => p.clinic_procedure_id)
        );
        setRefundProcedures([]);
        Swal.fire({
          icon: "success",
          title: "Extorno registrado com sucesso!",
        });
      })
      .catch((error) => {
        console.error("Erro ao registrar extorno:", error);
        Swal.fire({
          icon: "error",
          title: "Erro",
          text: "Falha ao registrar extorno.",
        });
      });

    onClose();
  };

  const filteredUnpaid = unpaidProcedures.filter(
    (p) =>
      p.procedure_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      p.cbhpm_code?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredPaid = paidProcedures
    //.filter((p) => !p.confirmed)
    .filter(
      (p) =>
        p.procedure_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        p.cbhpm_code?.toLowerCase().includes(searchTerm.toLowerCase())
    );

  useEffect(
    () => () => {
      receipts.forEach((r) => r.preview && URL.revokeObjectURL(r.preview));
    },
    [receipts]
  );

  /* ─────────── mantém cortesia em sincronia ─────────── */
  useEffect(() => {
    if (!hasCourtesy) return; // só faz algo se houver cortesia

    setPayments((prev) =>
      prev.map((p) =>
        p.method === "courtesy" ? { ...p, amount: totalAmount } : p
      )
    );
  }, [totalAmount, hasCourtesy]); // roda quando total mudar

  /* ─────────── render ─────────── */
  return (
    <div className="modal-overlay">
      <div className="procedures-modal payment-modal">
        {/* cabeçalho */}
        <div className="modal-header">
          <h2>
            {paymentStep === "select"
              ? "Pagamento de Procedimentos"
              : paymentStep === "address"
                ? "Selecionar endereço"
                : paymentStep === "confirm"
                  ? "Confirmar Pagamento"
                  : "Pagamento Concluído"}
          </h2>
          <button className="close-button" onClick={onClose}>
            <FontAwesomeIcon icon={faX} />
          </button>
        </div>

        <div className="modal-content-scrollable">
          {/* ───────── SELEÇÃO DE PROCEDIMENTOS PARA PAGAMENTO───────── */}
          {paymentStep === "select" && (
            <>
              {/* info paciente */}
              <div className="payment-patient-info">
                <div className="payment-patient-name">
                  <span>Paciente:</span>
                  <strong>{patient.name}</strong>
                </div>
                <div className="payment-date">
                  <span>Data:</span>
                  <strong>
                    {formatDateDDMMYYYY(schedule.schedules[0].date)}
                  </strong>
                </div>
              </div>
              {/* busca */}
              <div className="payment-search-container">
                <div className="search-input">
                  <FontAwesomeIcon icon={faSearch} />
                  <input
                    type="text"
                    placeholder="Pesquisar procedimento"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>
              {/* selecionar todos */}
              <div className="payment-selection-options">
                <label className="select-all-label">
                  <input
                    type="checkbox"
                    checked={allSelected}
                    onChange={handleSelectAll}
                  />
                  <span>Selecionar todos os procedimentos</span>
                </label>
              </div>
              {/* lista de procedimentos */}
              <div className="payment-procedures-list">
                <h5>Procedimentos Não Pagos</h5>

                {filteredUnpaid
                  .filter((proc) => proc.cancel == false)
                  .map((proc) => {
                    const isSelectedToPay = selectedProcedures.some(
                      (p) => p.procedure_id === proc.procedure_id
                    );

                    const selectedItem = selectedProcedures.find(
                      (p) => p.procedure_id === proc.procedure_id
                    );

                    const displayQuantity = selectedItem ? (selectedItem.quantity || 1) : (proc.quantity || 1);

                    return (
                      <div
                        key={proc.id}
                        className={`payment-procedure-item ${isSelectedToPay ? "selected" : ""
                          }`}
                        onClick={() => handleSelectProcedure(proc)}>
                        <input
                          type="checkbox"
                          readOnly
                          checked={isSelectedToPay}
                          style={{ margin: 9 }}
                        />
                        <div className="payment-procedure-details">
                          <h4>{proc.procedure_name}</h4>
                          <span className="payment-procedure-code">
                            ID: {proc.procedure_id}
                          </span>
                        </div>

                        <div className="d-flex align-items-center" style={{ minWidth: '100px', justifyContent: 'center' }}>
                          {isSelectedToPay ? (
                            <div className="d-flex align-items-center gap-2 bg-white rounded border p-1" onClick={(e) => e.stopPropagation()}>
                              <button
                                className="btn btn-sm btn-light p-0 d-flex align-items-center justify-content-center"
                                style={{ width: '36px', height: '36px' }}
                                onClick={(e) => handleQuantityChange(e, proc.procedure_id, -1)}
                              >
                                <FontAwesomeIcon icon={faMinus} />
                              </button>

                              <span className="fw-bold mx-2" style={{ minWidth: '20px', textAlign: 'center' }}>
                                {displayQuantity}
                              </span>

                              <button
                                className="btn btn-sm btn-light p-0 d-flex align-items-center justify-content-center"
                                style={{ width: '36px', height: '36px' }}
                                onClick={(e) => handleQuantityChange(e, proc.procedure_id, 1)}
                              >
                                <FontAwesomeIcon icon={faPlus} />
                              </button>
                            </div>
                          ) : (
                            <span className="text-muted">{displayQuantity}</span>
                          )}
                        </div>

                        {
                          proc.executing_company && (
                            <div className="payment-procedure-company payment-procedure-company-not-paid">
                              {proc.executing_company}
                            </div>
                          )
                        }

                        <div className="payment-procedure-price">
                          {formatMoney(proc.selling_price || 0)}
                        </div>
                      </div>
                    );
                  })}
                {filteredUnpaid.filter((proc) => proc.cancel == false)
                  .length === 0 && (
                    <p>Nenhum procedimento não pago encontrado.</p>
                  )}

                <h5>Procedimentos Pagos</h5>
                {filteredPaid.map((proc) => {
                  const isSelectedToRefund = refundProcedures
                    .filter((p) => p.cancel == true)
                    .filter((p) => p.is_paid == true)
                    .some((p) => p.procedure_id === proc.procedure_id);
                  return (
                    <div
                      key={proc.id}
                      className={`payment-procedure-item paid ${isSelectedToRefund ? "selected" : ""
                        }`}
                      onClick={() => handleSelectRefund(proc)}>
                      <img
                        src={extorn}
                        width={30}
                        style={{ opacity: isSelectedToRefund ? 1 : 0.35 }}
                        alt="Extornar"
                      />
                      <FontAwesomeIcon icon={faCheckCircle}
                        className={`status-icon status-${proc.confirmed
                          ? "confirmed"
                          : proc.cancel
                            ? "cancelled"
                            : "scheduled"
                          }`}
                      />
                      <div className="payment-procedure-details">
                        <h4>{proc.procedure_name}</h4>
                        <span className="payment-procedure-code">
                          ID: {proc.procedure_id}
                        </span>
                      </div>

                      {
                        proc.executing_company && (
                          <div className="payment-procedure-company">
                            {proc.executing_company}
                          </div>
                        )
                      }

                      <div>
                        {proc.courtesy ? (
                          <img src={courtesy} width={50} alt="Cortesia" />
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="payment-procedure-price">
                        {formatMoney(proc.selling_price || 0)}
                      </div>
                    </div>
                  );
                })}
                {filteredPaid.filter((proc) => proc.cancel == true).length ===
                  0 && <p>Nenhum procedimento pago encontrado.</p>}
              </div>

              {/* resumo subtotal / desconto */}
              <div className="payment-summary">
                <div className="payment-subtotal">
                  <span>Subtotal:</span>
                  <span>{formatMoney(subtotal)}</span>
                </div>

                <div className="payment-discount-section">
                  <h4>Aplicar Desconto</h4>
                  <div className="discount-type-selector">
                    <label
                      className={
                        discountType === "percentage" ? "selected" : ""
                      }>
                      <input
                        type="radio"
                        name="discountType"
                        value="percentage"
                        checked={discountType === "percentage"}
                        onChange={() => handleDiscountTypeChange("percentage")}
                      />
                      <FontAwesomeIcon icon={faPercent} /> Percentual
                    </label>
                    <label
                      className={discountType === "fixed" ? "selected" : ""}>
                      <input
                        type="radio"
                        name="discountType"
                        value="fixed"
                        checked={discountType === "fixed"}
                        onChange={() => handleDiscountTypeChange("fixed")}
                      />
                      <FontAwesomeIcon icon={faDollarSign} /> Valor Fixo
                    </label>
                  </div>

                  <input
                    type="number"
                    min="0"
                    max={discountType === "percentage" ? 100 : subtotal}
                    step="0.01"
                    value={discountValue}
                    onChange={handleDiscountValueChange}
                    disabled={isEditingTotal}
                  />

                  {discountValue > 0 && (
                    <p>
                      Desconto aplicado: {formatMoney(calculateDiscount())}
                      {discountType === "percentage" && ` (${discountValue}%)`}
                    </p>
                  )}

                  {/*<label>
                    Motivo do desconto
                    <input
                      type="text"
                      value={discountReason}
                      onChange={(e) => setDiscountReason(e.target.value)}
                    />
                  </label> */}
                </div>

                {/* total + edição */}
                <div className="payment-total">
                  <span>Total a pagar:</span>
                  <div className="payment-total-net">
                    <span className="me-3">Recebido líquido com taxas:</span>
                    <strong>{formatMoney(currentNetTotal)}</strong>
                  </div>

                  {!isEditingTotal ? (
                    <>
                      <strong>{formatMoney(totalAmount)}</strong>
                    </>
                  ) : (
                    <>
                      <input
                        type="number"
                        min="0"
                        step="0.01"
                        value={customTotal}
                        onChange={(e) =>
                          setCustomTotal(parseFloat(e.target.value) || 0)
                        }
                      />
                      <button onClick={handleSaveCustomTotal} title="Salvar">
                        <FontAwesomeIcon icon={faSave} />
                      </button>
                      <button onClick={handleCancelEditTotal} title="Cancelar">
                        <FontAwesomeIcon icon={faX} />
                      </button>
                    </>
                  )}
                </div>
              </div>

              {/* FORMAS DE PAGAMENTO */}
              <div className="payment-methods-container">
                <h3>Formas de Pagamento</h3>
                {payments.map((p, idx) => (
                  <div key={idx} className="payment-row">
                    <select
                      value={p.method}
                      onChange={(e) => handleMethodChange(idx, e.target.value)}>
                      {PAYMENT_OPTIONS.map(({ value, label }) => (
                        <option
                          key={value}
                          value={value}
                          disabled={isMethodInUse(value, idx)}>
                          {label}
                        </option>
                      ))}
                    </select>

                    <input 
                    type="text"
                    className="payment-amount-input" 
                    disabled={p.method === "courtesy"}
                      style={{
                        height: "38px",
                        padding: "0 10px",
                        width: "100%",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                      value={p.amount}
                      onChange={(values) =>
                        updatePayment(
                          idx,
                          "amount",
                          formatCurrency(values.target.value)
                          //values.target.value
                        )
                      }
                      placeholder="Valor"
                    />


                    {/* Usando NumericFormat para o valor de pagamento */}
                    {/* <NumericFormat
                      className="payment-amount-input"
                      disabled={p.method === "courtesy"}
                      style={{
                        height: "38px",
                        padding: "0 10px",
                        width: "100%",
                        borderRadius: "6px",
                        border: "1px solid #ccc",
                      }}
                      thousandSeparator="."
                      decimalSeparator=","
                      prefix="R$ "
                      decimalScale={2}
                      fixedDecimalScale
                      value={p.amount === 0 ? '' : p.amount}
                      onValueChange={(values) =>
                        updatePayment(
                          idx,
                          "amount",
                          parseFloat(values.value.replace(",", ".")) || 0
                        )
                      }
                      placeholder="Valor"
                    /> */}

                    {(p.method === "credit" || p.method === "debit") && (
                      <div>
                        <button
                          type="button"
                          className="select-fee-button"
                          style={{
                            height: "38px",
                            width: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: "6px",
                            border: `${p.brand ? "1px solid green" : "1px solid red"
                              }`,
                            fontSize: "12px",
                          }}
                          onClick={() => openSelector(idx)}>
                          {p.brand ? (
                            <span style={{ color: "green" }}>
                              {p.installments}x {p.tax.toFixed(2)}%
                            </span>
                          ) : (
                            <FontAwesomeIcon icon={faCreditCard} className="mr-2" />
                          )}
                        </button>
                      </div>
                    )}

                    {payments.length > 1 && (
                      <button
                        onClick={() => removePayment(idx)}
                        title="Excluir forma">
                        <FontAwesomeIcon icon={faTrash} />
                      </button>
                    )}
                  </div>
                ))}
                {!hasCourtesy && remaining > 0 && (
                  <button className="add-payment-button" onClick={addPayment}>
                    + Adicionar forma ({formatMoney(remaining)} restantes)
                  </button>
                )}{" "}
                {/* upload comprovantes */}
                <div className="payment-receipt-upload">
                  <h4>Comprovantes de Pagamento</h4>

                  <button
                    className="upload-button"
                    onClick={() => fileInputRef.current.click()}>
                    <FontAwesomeIcon icon={faUpload} /> Anexar Comprovantes
                  </button>

                  <input
                    type="file"
                    ref={fileInputRef}
                    multiple
                    accept="image/*,application/pdf"
                    onChange={handleFilesChange}
                    className="file-input-hidden"
                  />

                  {/* lista / pré-visualização */}
                  {receipts.length > 0 && (
                    <ul className="receipt-list">
                      {receipts.map(({ file, preview }, idx) => (
                        <li key={idx} className="receipt-item">
                          {preview ? (
                            <img src={preview} alt={file.name} />
                          ) : (
                            <FontAwesomeIcon icon={faImage} />
                          )}
                          <span>{file.name}</span>
                          <button onClick={() => removeReceipt(idx)}>
                            <FontAwesomeIcon icon={faTrash} />
                          </button>
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </>
          )}

          {/* SELEÇÃO DE ENDEREÇO */}
          {paymentStep === "address" && (
            <>
              <div className="address-selection-container">
                <div className="d-flex justify-content-between align-items-center mb-4">
                  <h4 className="mb-0">Selecionar Endereço</h4>
                  <Button
                    variant="outline-primary"
                    size="sm"
                    onClick={() => setShowAddressModal(true)}
                  >
                    <FontAwesomeIcon icon={faPlus} className="me-1" />
                    Novo Endereço
                  </Button>
                </div>

                <div className="row">
                  {addresses.map((address) => (
                    <div key={address.id} className="col-md-6 mb-3">
                      <Card
                        className={`address-card ${selectedAddress === address.id ? 'border-primary' : ''}`}
                        style={{ cursor: 'pointer' }}
                        onClick={() => handleAddressSelect(address.id)}
                      >
                        <Card.Body>
                          <div className="d-flex align-items-start">
                            <Form.Check
                              type="radio"
                              name="address"
                              checked={selectedAddress === address.id}
                              onChange={() => handleAddressSelect(address.id)}
                              className="me-3"
                            />
                            <div className="flex-grow-1">
                              <div className="d-flex align-items-center mb-2">
                                <FontAwesomeIcon icon={faMapPin} className="text-muted me-1" />
                                <strong className="text-truncate">
                                  {address.street}, {address.number}
                                </strong>
                                {address.default && (
                                  <span className="badge bg-primary ms-2">Padrão</span>
                                )}
                              </div>

                              {address.complement && (
                                <p className="text-muted small mb-1">
                                  Complemento: {address.complement}
                                </p>
                              )}

                              <p className="text-muted small mb-1">
                                Bairro: {address.district}
                              </p>

                              <p className="text-muted small mb-1">
                                CEP: {address.zipcode}
                              </p>

                              <p className="text-muted small mb-0">
                                Cidade: {address.city}-{address.state}
                              </p>
                            </div>
                          </div>
                        </Card.Body>
                      </Card>
                    </div>
                  ))}
                </div>

                {addresses.length === 0 && (
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon={faPlus} className="text-muted mb-3" />
                    <p className="text-muted">Nenhum endereço cadastrado</p>
                    <Button
                      variant="primary"
                      onClick={() => setShowAddressModal(true)}
                    >
                      <FontAwesomeIcon icon={faPlus} className="me-1" />
                      Cadastrar Endereço
                    </Button>
                  </div>
                )}
              </div>

              {/* Modal para novo endereço */}
              <Modal
                show={showAddressModal}
                onHide={() => setShowAddressModal(false)}
              >
                <Modal.Header closeButton>
                  <Modal.Title>Cadastrar Novo Endereço</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form>
                    <Row>
                      <Col md={8}>
                        <Form.Group className="mb-3">
                          <Form.Label>Endereço *</Form.Label>
                          <Form.Control
                            type="text"
                            value={newAddress.street}
                            onChange={(e) => setNewAddress(prev => ({
                              ...prev,
                              street: e.target.value
                            }))}
                            placeholder="Digite o endereço"
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Número *</Form.Label>
                          <Form.Control
                            type="text"
                            value={newAddress.number}
                            onChange={(e) => setNewAddress(prev => ({
                              ...prev,
                              number: e.target.value
                            }))}
                            placeholder="Nº"
                            required
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Row>
                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>Bairro *</Form.Label>
                          <Form.Control
                            type="text"
                            value={newAddress.district}
                            onChange={(e) => setNewAddress(prev => ({
                              ...prev,
                              district: e.target.value
                            }))}
                            placeholder="Digite o bairro"
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col md={6}>
                        <Form.Group className="mb-3">
                          <Form.Label>CEP *</Form.Label>
                          <Form.Control
                            type="text"
                            value={newAddress.zipcode}
                            onChange={(e) => setNewAddress(prev => ({
                              ...prev,
                              zipcode: e.target.value
                            }))}
                            placeholder="00000-000"
                            required
                          />
                        </Form.Group>
                      </Col>

                    </Row>

                    <Row>
                      <Col md={8}>
                        <Form.Group className="mb-3">
                          <Form.Label>Cidade *</Form.Label>
                          <Form.Control
                            type="text"
                            value={newAddress.city}
                            onChange={(e) => setNewAddress(prev => ({
                              ...prev,
                              city: e.target.value
                            }))}
                            placeholder="Digite a cidade"
                            required
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group className="mb-3">
                          <Form.Label>Estado *</Form.Label>
                          <Form.Control
                            type="text"
                            value={newAddress.state}
                            onChange={(e) => setNewAddress(prev => ({
                              ...prev,
                              state: e.target.value
                            }))}
                            placeholder="Digite a cidade"
                            required
                          />
                        </Form.Group>

                      </Col>
                    </Row>

                    <Form.Group className="mb-3">
                      <Form.Label>Complemento</Form.Label>
                      <Form.Control
                        type="text"
                        value={newAddress.complement}
                        onChange={(e) => setNewAddress(prev => ({
                          ...prev,
                          complement: e.target.value
                        }))}
                        placeholder="Apto, sala, etc."
                      />
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label>&nbsp;</Form.Label>
                      <Form.Check
                        type="checkbox"
                        label="Padrão"
                        checked={newAddress.default}
                        onChange={(e) => setNewAddress(prev => ({
                          ...prev,
                          default: e.target.checked
                        }))}
                      />
                    </Form.Group>


                  </Form>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    variant="secondary"
                    onClick={() => setShowAddressModal(false)}
                  >
                    Cancelar
                  </Button>
                  <Button
                    variant="primary"
                    onClick={handleNewAddressSubmit}
                  //disabled={!newAddress.address || !newAddress.number || !newAddress.neighborhood || !newAddress.zip_code || !newAddress.city}
                  >
                    Cadastrar Endereço
                  </Button>
                </Modal.Footer>
              </Modal>
            </>
          )}

          {/* ───────── CONFIRMAÇÃO ───────── */}
          {paymentStep === "confirm" && (
            <div className="payment-confirmation-container">
              <div className="confirmation-header">
                <FontAwesomeIcon icon={faCircleInfo} className="icon-alert" />
                <p className="confirmation-title">
                  Confirme os detalhes do pagamento
                </p>
              </div>

              <div className="confirmation-section">
                <h3 className="section-title">Pagador</h3>
                <p>
                  <strong>Nome:</strong> {patient.name}
                </p>
                <p>
                  <strong>CPF:</strong> {patient.cpf}
                </p>
              </div>

              <div className="confirmation-section">
                <h3 className="section-title">Formas de Pagamento</h3>
                <ul className="payment-list">
                  {payments.map((p, i) => (
                    <li key={i}>
                      <strong>
                        {p.method === "credit"
                          ? "Cartão de Crédito"
                          : p.method === "debit"
                            ? "Cartão de Débito"
                            : p.method === "cash"
                              ? "Dinheiro"
                              : p.method === "courtesy"
                                ? "Cortesia"
                                : "PIX"}
                      </strong>
                      {" – "}
                      {p.amount}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="confirmation-section">
                <h3 className="section-title">
                  Procedimentos ({selectedProcedures.length})
                </h3>
                {selectedProcedures.map((proc) => (
                  <p key={proc.code}>
                    {proc.procedure_name} — {formatMoney(proc.selling_price)}
                  </p>
                ))}
              </div>

              <div className="confirmation-section totals">
                <p>
                  <strong>Subtotal:</strong> {formatMoney(subtotal)}
                </p>
                {discountValue > 0 && (
                  <p>
                    <strong>Desconto:</strong>{" "}
                    {formatMoney(calculateDiscount())}
                  </p>
                )}
                <p className="total-line">
                  <strong>Total:</strong> {formatMoney(totalAmount)}
                </p>
              </div>
            </div>
          )}

          {/* ───────── TAXA ───────── */}
          {/* FeeSelectorModal */}
          <FeeSelectorModal
            show={showFeeSelector}
            onHide={() => setShowFeeSelector(false)}
            initialBrand={payments[currentIdx]?.brand}
            initialInstallments={payments[currentIdx]?.installments}
            onConfirm={handleConfirmFee}
          />

          {/* ───────── SUCESSO ───────── */}
          {paymentStep === "success" && (
            <div className="payment-success">
              <div className="payment-success-icon">
                <FontAwesomeIcon icon={faCheckCircle} />
              </div>
              <div className="payment-success-client">
                <h4>{patient.name}</h4>
                <p>CPF: {patient.cpf}</p>
              </div>

              <h3>Pagamento registrado!</h3>
              <ul className="payment-list">
                {payments.map((p, i) => (
                  <li key={i}>
                    <strong>
                      {p.method === "credit"
                        ? "Crédito"
                        : p.method === "debit"
                          ? "Débito"
                          : p.method === "cash"
                            ? "Dinheiro"
                            : p.method === "courtesy"
                              ? "Cortesia"
                              : "PIX"}
                    </strong>
                    {" – "}
                    {formatMoney(p.amount)}
                  </li>
                ))}
                <h3>Procedimentos ({selectedProcedures.length})</h3>
                {selectedProcedures.map((proc) => (
                  <p key={proc.code}>
                    {proc.procedure_name} — {formatMoney(proc.selling_price)}
                  </p>
                ))}

                <li>
                  <strong>Total:</strong> {formatMoney(totalAmount)}
                </li>
              </ul>
              <p>{new Date().toLocaleString("pt-BR")}</p>
              {receiptPreview && (
                <img
                  src={receiptPreview}
                  alt="Comprovante"
                  className="receipt-preview-success"
                />
              )}
            </div>
          )}
        </div>

        {/* ───────── FOOTER ───────── */}
        <div className="modal-footer">
          {paymentStep === "select" && (
            <div className="payment-actions">
              <button className="cancel-button" onClick={onClose}>
                Cancelar
              </button>
              {/* {selectedProcedures.length > 0 && (
                <button
                  className="process-payment-button"
                  onClick={}>
                  <Receipt size={18} /> Processar Pagamento
                </button>
              )} */}
              {
                (paymentStep === 'select' && selectedProcedures.length > 0) && (
                  <button
                    className="process-payment-button"
                    onClick={handleAdvance}>
                    <FontAwesomeIcon icon={faArrowRight} /> Avançar
                  </button>
                )
              }

              {
                paidProcedures.length > 0 && (
                  <button
                    className="process-payment-button"
                    onClick={() => handlePrintReceipt(paidProcedures)}>
                    <FontAwesomeIcon icon={faPrint} /> Imprimir Recibo
                  </button>
                )
              }

              {refundProcedures.length > 0 && (
                <button
                  className="confirm-refund-button"
                  onClick={handleConfirmRefund}>
                  <img src={extorn} width={18} alt="Extornar" /> Confirmar
                  Extorno
                </button>
              )}
            </div>
          )}

          {paymentStep === "address" && (
            <div className="payment-actions">
              <button
                className="cancel-button"
                onClick={() => setPaymentStep('select')}
              >
                Voltar
              </button>
              <button
                className="process-payment-button"
                onClick={handleAdvanceFromAddress}
              >
                <FontAwesomeIcon icon={faArrowRight} /> Avançar
              </button>
            </div>
          )}

          {paymentStep === "confirm" && (
            <div className="payment-confirmation-actions">
              <button
                className="back-button"
                onClick={() => setPaymentStep("address")}>
                Voltar
              </button>
              <button
                className="confirm-payment-button"
                onClick={handleConfirmPayment}>
                <FontAwesomeIcon icon={faCheckCircle} /> Confirmar Pagamento
              </button>
            </div>
          )}

          {paymentStep === "success" && (
            <div className="payment-success-actions">
              <button
                className="print-receipt-button"
                onClick={() => handlePrintReceipt(selectedProcedures)}>
                <FontAwesomeIcon icon={faPrint} /> Imprimir Recibo
              </button>
              <button className="close-success-button" onClick={onClose}>
                <FontAwesomeIcon icon={faArrowRight} /> Concluir
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
